angular.module('gym.calendar').factory('CalendarLastVisitedViewService', ["CwStorage", function(CwStorage) {
  return {
    get: function() {
      return CwStorage.getItem('calendarLastVisitedView') || 'gym.calendar';
    },
    set: function(view) {
      return CwStorage.setItem('calendarLastVisitedView', view);
    }
  };
}]);
